import {
  FETCH_INVOICES_REQUEST,
  FETCH_INVOICES_SUCCESS,
  FETCH_INVOICES_FAILURE,
  GENERATE_INVOICE_SUCCESS
} from "../actions/InvoiceActions";

const initialState = {
  invoices: [],
  count: 0,
  loading: false,
  error: null
};

const InvoiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_INVOICES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    
    case FETCH_INVOICES_SUCCESS:
      return {
        ...state,
        loading: false,
        invoices: action.payload.invoices,
        count: action.payload.count,
        error: null
      };
    
    case FETCH_INVOICES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    
    case GENERATE_INVOICE_SUCCESS:
      return {
        ...state,
        invoices: [action.payload, ...state.invoices]
      };
    
    default:
      return state;
  }
};

export default InvoiceReducer;